import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IRulesPageDataResult {
  fetch: {
    Common: {
      Rules: {
        TitleColor: string | null;
        BackgroundColor: string | null;
        Lists: {
          NumberBackground: string | null;
          NumberActiveBackground: string | null;
          QuestionsBackground: string | null;
        };
      } | null;
    };
    Country: {
      RulesPage: {
        Header: string;
        Subtitle: string | null;
        Rules: Array<{
          Title: string;
          Content: string;
        }>;
      };
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithRulesPageQueryProps = QueryResult<IRulesPageDataResult>;

class RulesPageQuery extends Query<IRulesPageDataResult, IVariables> {}

const withRulesPageQuery = <P extends WithRulesPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithRulesPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <RulesPageQuery
      query={queries.GET_RULES_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </RulesPageQuery>
  );
};

export default withRulesPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withRulesPageQuery.tsx